import { http } from "./http"
import { ExchangeRate, ExchangeRatePayload } from "models/exchangeRates"

// ** FETCH (GET) **
export const fetchCurrencyExchanges = async (clientId: string) => {
  const response = await http
    .get(`currency-exchanges/clients/${clientId}`)
    .json()
  return response as ExchangeRate[]
}

// ** CREATE (POST) **
export const createCurrencyExchange = async (pld: ExchangeRatePayload) => {
  const json = pld
  const response = await http.post("currency-exchanges/clients", { json })
  const { data } = await response.json()
  return data as ExchangeRate
}

// ** UPDATE (PUT) **
export const updateCurrencyExchange = async (pld: ExchangeRatePayload) => {
  const json = pld
  try {
    const { data } = await http
      .put("currency-exchanges/clients", { json })
      .json<{ data: ExchangeRate }>()
    return data
  } catch (error: any) {
    const [errorField] = error.json.fields
    throw new Error(errorField.message)
  }
}

// ** DELETE (DELETE) **
export const deleteCurrencyExchange = async ({
  clientId,
  sourceCurrency,
  targetCurrency,
}: {
  clientId: string
  sourceCurrency: string
  targetCurrency: string
}) => {
  const response = await http.delete(
    `currency-exchanges/clients/${clientId}/${sourceCurrency}/${targetCurrency}`,
  )

  // Handle the 204 No Content response
  if (response.status === 204) {
    return null // No content to return
  }

  if (!response.ok) {
    throw new Error("Failed to delete exchange rate")
  }

  // Only return JSON if there's content
  return response.json()
}
